import { useQueryClient } from 'react-query';
import { GET_AGENTS_KEY } from './useGetAgents';

export function useRefetchAgents() {
    const queryClient = useQueryClient();

    return {
        refetchAgents: () => queryClient.refetchQueries(GET_AGENTS_KEY),
    };
}
